import React from 'react';
import { Link } from 'react-router-dom';

// Plain-language privacy policy for the tenant portal. English only, like the Terms and Refund pages.
export default function Privacy() {
  const wrap = { maxWidth: 900, margin: '40px auto', background: 'var(--surface)', padding: '36px 44px', borderRadius: 18, boxShadow: '0 4px 28px rgba(0,0,0,0.08)', lineHeight: 1.55, fontSize: 15, color: 'var(--ink)' };
  const h1 = { fontSize: 30, marginTop: 0, marginBottom: 6, color: 'var(--primary)', letterSpacing: '0.5px' };
  const meta = { fontSize: 12, color: 'var(--muted)', marginBottom: 24 };
  const h2 = { fontSize: 18, margin: '26px 0 8px', color: 'var(--ink)' };
  const list = { margin: '6px 0 12px 20px', padding: 0 };
  return (
    <div style={wrap}>
      <h1 style={h1}>Privacy Policy</h1>
      <div style={meta}>Last updated on 27 September 2026</div>
      <p>This policy explains what personal information the VGR rent payment website (vgrpay.uk) collects from tenants, why, and how it is handled. The site is run by the property owner, Gopalareddy V ("we", "us").</p>

      <h2 style={h2}>1. What we collect</h2>
      <ul style={list}>
        <li>Your name, username, mobile number and email address.</li>
        <li>Your move-in date, security deposit details and rent, water, electricity and other bills, with their payment status and dates.</li>
        <li>Complaints you raise and requests you make, such as a request to vacate.</li>
        <li>Identity documents (for example Aadhaar) of you and other occupants that you upload, as required for tenancy records.</li>
        <li>Basic technical information needed to keep the site secure, such as login attempts.</li>
      </ul>

      <h2 style={h2}>2. Why we collect it</h2>
      <ul style={list}>
        <li>To create your account and let you log in.</li>
        <li>To generate bills, record payments and deposits, and send you receipts and notices by email.</li>
        <li>To keep tenancy records and verify who is living in the property.</li>
        <li>To respond to your complaints and requests.</li>
      </ul>

      <h2 style={h2}>3. Online payments</h2>
      <p>Online payments are processed by Razorpay. Your card, UPI or bank details are entered on Razorpay's secure page and are not stored on this website. We receive only the result of the payment (for example, paid or failed) and a payment reference.</p>

      <h2 style={h2}>4. Who can see your information</h2>
      <ul style={list}>
        <li>You can see your own bills, payments, deposit and documents.</li>
        <li>The owner can see tenant records, including uploaded documents, in order to manage the tenancy.</li>
        <li>We do not sell your information or use it for advertising.</li>
        <li>We share information with service providers only as needed to run the site: Razorpay (payments), an email service (notifications and one-time passwords) and cloud hosting and storage providers.</li>
        <li>We may disclose information if the law requires it.</li>
      </ul>

      <h2 style={h2}>5. Security</h2>
      <p>Passwords are stored in a hashed form, and access to documents is limited to the tenant concerned and the owner. No online system is completely secure, so please keep your password and registration key private.</p>

      <h2 style={h2}>6. How long we keep it</h2>
      <p>We keep tenancy, billing and payment records for as long as they are needed for the tenancy and for accounting, tax and legal purposes. Records of a tenant who has moved out are archived.</p>

      <h2 style={h2}>7. Your choices</h2>
      <p>You can ask us to correct wrong information, or to delete information we no longer need to keep, by contacting the owner. Some records may have to be kept where the law or an unsettled account requires it.</p>

      <h2 style={h2}>8. Changes</h2>
      <p>We may update this policy. The date at the top shows when it was last changed.</p>

      <h2 style={h2}>9. Contact</h2>
      <p>Gopalareddy V, No.36/30/1, Kachanayakanahalli, Near milk diary, Hennagara post, Anekal taluk, Bangalore-560099. Phone: +91 9964656247.</p>

      <p style={{ marginTop: 28 }}><Link to="/" style={{ color: 'var(--primary)' }}>Back to home</Link></p>
    </div>
  );
}
